import type { IconSvgObject } from './types';

const CursorInfo02Icon: IconSvgObject = [
  ["path", { d: "M4.59999 2.03043L19.7174 7.84482C20.1034 7.99327 20.0909 8.54358 19.6986 8.67435L13.1394 10.8607C13.0078 10.9046 12.9045 11.0079 12.8607 11.1395L10.6743 17.6986C10.5435 18.0909 9.99322 18.1034 9.84478 17.7175L4.03038 2.60004C3.89328 2.24357 4.24353 1.89333 4.59999 2.03043Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 21.99V22M16 15.9976C16 14.8944 16.8954 14 18 14C19.1046 14 20 14.8944 20 15.9976C20 16.5747 19.755 17.0946 19.3632 17.4593C18.7572 18.0234 18 18.666 18 19.4935", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CursorInfo02Icon;
